
export default {
    name: "mix-article-loading",
}
